export default {
  RETAIL_REIT: 'Retail REITs',
};
